export const MESSAGE_VALIDATION = {
	DNI: 'DNI inválido. Eliminar espacios en blanco o letras',
};

export const WHATSAPP_PHONE_NUMBER = '51965698337';
